import api from './client'

export interface SatPlan {
  id: number
  plan_code: string
  name: string
  price_in_cent: number
  description: string | null
  is_active: boolean
  platform_type: string
}

export interface SatPlanPayload {
  plan_code: string
  name: string
  price_in_cent: number
  description?: string | null
  is_active: boolean
  platform_type: string
}

export const satPlansApi = {
  list: () => api.get<SatPlan[]>('/admin/sat-plans'),
  create: (data: SatPlanPayload) => api.post<SatPlan>('/admin/sat-plans', data),
  update: (id: number, data: Partial<SatPlanPayload>) => api.put<SatPlan>(`/admin/sat-plans/${id}`, data),
  delete: (id: number) => api.delete<{ message: string }>(`/admin/sat-plans/${id}`),
}
